import React, { PureComponent } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import Picture from '../components/picture';

const ITEMS_PER_PAGE = 10;

export default class IndexPage extends PureComponent {
  state = {
    page: 1,
    selectedPictureId: null
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  handleClick = e => {
    if (!e.target.classList.contains('dots')) {
      this.setState({ selectedPictureId: -1 });
    }
  };

  loadItems = page => {
    this.setState({ page: page + 1 });
  };

  onPictureClick = id => {
    this.setState({ selectedPictureId: id });
  };

  render() {
    const items = this.props.data.allDatoCmsPicture.edges;

    const { page, selectedPictureId } = this.state;

    const end = page * ITEMS_PER_PAGE;

    return (
      <div>
        <InfiniteScroll
          pageStart={1}
          initialLoad={false}
          loadMore={this.loadItems}
          hasMore={page < items.length}
        >
          {items
            .slice(0, end)
            .map(({ node: { id, ...rest } }) => (
              <Picture
                key={id}
                id={id}
                {...rest}
                selected={id === selectedPictureId}
                onClick={this.onPictureClick}
              />
            ))}
        </InfiniteScroll>
      </div>
    );
  }
}

export const query = graphql`
  query PicturesQuery {
    allDatoCmsPicture(sort: { fields: [position], order: DESC }) {
      edges {
        node {
          ...PictureFragment
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js